/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { basicLayoutStyles } from "./styles";
import { NavBar } from "../../components/NavigationBar";
import { pageObj } from "../../components/NavigationBar/interfaces";
import {
  navbarDetails,
  socialMediaCred,
  footerDetails,
  footerContactDetails,
  pageTypes,
} from "../../constants/commons";
import { SignUpModal } from "../../modals/SignUpModal";
import { Footer } from "../../components/Footer";
import { color } from "../../constants/commons";
import { routeURL } from "../../constants/commons";
import { useIsMobile, useIsTab } from "../../hooks/useIsMobile";
interface BasicLayoutProps extends RouteComponentProps {
  isProfilePictureUpdated?: boolean;
}

const BasicLayout: React.FunctionComponent<BasicLayoutProps> = (props) => {
  const { isProfilePictureUpdated } = props;
  const { pathname } = props.location;
  const isMobileView = useIsMobile();
  const isTabView = useIsTab();

  // Function which shows the footer only for PRE-LOGIN pages
  // const showFooter = React.useMemo(() => {
  //   return (
  //     pathname.includes(routeURL.partnerPage("")) ||
  //     pathname.includes(routeURL.registrationPage) ||
  //     !(
  //       pathname.includes(routeURL.finalCongratulationsPage) ||
  //       pathname.includes(routeURL.finalAgreementPage)
  //     )
  //   );
  // }, [pathname]);

  // Hook which changes the classNAme of the footer based on the pathName
  const changeFooterClassName = React.useMemo(() => {
    return (
      pathname.includes(routeURL.partnerPage("")) ||
      pathname.includes(routeURL.dashboard) ||
      pathname.includes(routeURL.finalCongratulationsPage) ||
      pathname.includes(routeURL.finalAgreementPage)
    );
  }, [pathname]);

  const [pageDetails, setPageDetails] = React.useState<pageObj>({} as pageObj);

  // State for maintaining the state of modal
  const [openSignUpModal, setOpenSignUpModal] = React.useState<boolean>(false);
  // State for maintaining the type of modal to be opened
  const [modalType, setmodalType] = React.useState<string>();

  // Function called when the button to open modal is clicked
  const onButtonClickAction = (clickType: string) => {
    setmodalType(clickType);
    setOpenSignUpModal(true);
  };
  // Function called when the modal is cancelled
  const handleCancelModal = () => {
    setOpenSignUpModal(false);
  };

  React.useEffect(() => {
    if (pathname.includes(routeURL.partnerPage(""))) {
      const urlInfo = pathname.split("/");
      setPageDetails({
        page: pageTypes.partnerCentricPage,
        pageDetails: urlInfo[2],
      });
    } else {
      setPageDetails({} as pageObj);
    }
  }, [pathname]);

  return (
    <div
      className="basic-layout"
      css={basicLayoutStyles(
        props.location.pathname === routeURL.feeStructurePage
          ? `linear-gradient(-180deg, ${color.whitishGray} 0%, ${color.white} 100%);`
          : props.location.pathname === routeURL.landingPage
          ? `${color.whitishGray}`
          : color.white
      )}
    >
      {!(
        (pathname.includes(routeURL.registrationPage) &&
          (isMobileView || isTabView)) ||
        pathname.includes(routeURL.finalCongratulationsPage) ||
        pathname.includes(routeURL.finalAgreementPage)
      ) && (
        <NavBar
          isProfilePictureUpdated={isProfilePictureUpdated}
          navLinks={navbarDetails}
          onButtonClickAction={onButtonClickAction}
          pageObj={pageDetails}
          blackNav={pathname.includes(routeURL.dashboard) ? true : false}
        />
      )}

      {openSignUpModal && (
        <SignUpModal
          visible={openSignUpModal}
          handleCancel={handleCancelModal}
          modalType={modalType}
        />
      )}
      {props.children}
      {/* {showFooter && ( */}
      <Footer
        heading={footerDetails}
        socialMediaCred={socialMediaCred}
        footerContactDetails={footerContactDetails}
        onButtonClickAction={onButtonClickAction}
        className={`${
          changeFooterClassName
            ? "partner-page-footer-layout"
            : "footer-layout no-gutters"
        }`}
      />
      {/* )} */}
    </div>
  );
};

const BasicLayoutWithRouter = withRouter(BasicLayout);

export default BasicLayoutWithRouter;
